module.exports = require("./../../_gen/starling/display/DisplayObject");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/display/DisplayObject.js
// module id = 165
// module chunks = 0